import { render, staticRenderFns } from "./MobileLocaleDock.vue?vue&type=template&id=d724bc42&scoped=true"
import script from "./MobileLocaleDock.vue?vue&type=script&lang=js"
export * from "./MobileLocaleDock.vue?vue&type=script&lang=js"
import style0 from "./MobileLocaleDock.vue?vue&type=style&index=0&id=d724bc42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d724bc42",
  null
  
)

export default component.exports